import * as React from "react"
const RisingFast = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <path
     fill="#BDDEFF"
      fillOpacity={1}
      d="M9.043 1.313c1.643 0 2.934 0 3.941.135 1.033.14 1.852.429 2.495 1.073.644.643.934 1.462 1.073 2.495.135 1.007.136 2.298.136 3.941v.086c0 1.643 0 2.934-.136 3.941-.14 1.033-.429 1.852-1.072 2.495-.644.644-1.463.934-2.496 1.073-1.007.135-2.298.136-3.941.136h-.086c-1.643 0-2.934 0-3.941-.136-1.033-.14-1.852-.429-2.495-1.072-.644-.644-.934-1.463-1.073-2.496-.135-1.007-.136-2.298-.135-3.941v-.086c0-1.643 0-2.934.135-3.941.14-1.033.429-1.852 1.073-2.495.643-.644 1.462-.934 2.495-1.073 1.007-.135 2.298-.136 3.941-.135h.086ZM5.25 11.437a.562.562 0 0 0-.563.563v1.5a.562.562 0 1 0 1.125 0V12a.562.562 0 0 0-.562-.563Zm3.75-.75a.562.562 0 0 0-.563.563v2.25a.562.562 0 1 0 1.126 0v-2.25A.562.562 0 0 0 9 10.687Zm3.75-1.5a.562.562 0 0 0-.563.563v3.75a.562.562 0 1 0 1.126 0V9.75a.562.562 0 0 0-.563-.563Zm-.855-5.248a4.626 4.626 0 0 0-.511.066l-.025.004-.95.157a.562.562 0 0 0 .183 1.11l.543-.09C9.723 7.169 7.465 8.064 4.5 8.064a.563.563 0 0 0 0 1.124c3.242 0 5.924-1.008 7.6-3.416l.109.384a.563.563 0 0 0 1.082-.31l-.24-.832-.006-.027a3.474 3.474 0 0 0-.153-.455.976.976 0 0 0-.409-.467 1.062 1.062 0 0 0-.588-.125Z"
    />
  </svg>
)
export default RisingFast
